(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('AttoDialogController', AttoDialogController);

    AttoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Atto'];

    function AttoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Atto) {
        var vm = this;

        vm.atto = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.atto.id !== null) {
                Atto.update(vm.atto, onSaveSuccess, onSaveError);
            } else {
                Atto.save(vm.atto, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('gestioneAttiApp:attoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dataProtocollo = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
